export const COMPANY_ID_MAPPINGS = {
  'Comercial Zaffari': [
    '430', '1612', '1966', '2217', '2218', '2219', '2316', '2317', '2318', '2320', 
    '2322', '2720', '2890', '3204', '3320', '3431', '3510', '3662', '4005', '4056', 
    '4107', '4109', '4141', '4176', '4229', '4267', '4307', '5488', '6093', '6155', 
    '7284', '7404', '7405', '7406', '7664'
  ],
  'Stok Center': [
    '2319', '2321', '4598', '4763', '5096', '5360', '5375', '5707', '6092', '6503', 
    '6854', '7128', '7286'
  ],
  'Cia. Zaffari': [
    '2824', '2826', '3839', '3889', '3903', '4018', '4023', '4249', '4700', '4913', 
    '4924', '5144', '6173'
  ]
};

export default COMPANY_ID_MAPPINGS;
